import { makeStyles } from 'tss-react/mui';
import { Theme } from '@mui/material';

export const useStyles = makeStyles()((theme: Theme) => ({
  root: {
    display: 'flex',
    height: '100%',
    flex: 1,
    margin: theme.spacing(0, 2),
    justifyContent: 'center',
    alignItems: 'center',
  },

  popoverPaper: {
    width: '100%',
    height: '100%',
    maxHeight: 'unset',
    maxWidth: 'unset',
  },

  menu: {
    '& .MuiPaper-root': {
      borderRadius: theme.spacing(0),
      height: `calc(100% - ${theme.spacing(7.5)})`,
      background: theme.palette.sidebar.background.main,
      marginTop: theme.spacing(1.5),
      boxShadow: 'none',
    },

    '& .MuiMenuItem-root': {
      padding: theme.spacing(0),
      background: theme.palette.background.paper,
    },

    '& .MuiDivider-root': {
      marginTop: theme.spacing(0),
      marginBottom: theme.spacing(0),
    },

    '& .MuiList-root': {
      paddingTop: theme.spacing(0),
    },
  },

  navigationItem: {
    padding: theme.spacing(2.5, 3.125),
  },

  gameNavigationItem: {
    padding: theme.spacing(0, 1.25),
  },

  profile: {
    padding: theme.spacing(1.75, 3.125),
  },

  control: {
    display: 'block',
  },
}));
